import { useQuery } from '@apollo/client';
import { NextPageWithLayout } from '@scorenco/next';
import { useRouter } from 'next/router';

import { WidgetsStyle } from '../../../components';
import { WeekEventsWidget } from '../../../components/Widgets';
import { WidgetsLayout } from '../../../layouts';
import { GetClubWidgetSettingsDocument } from '../../_internal/Widget.query.generated';

const WeekEvents: NextPageWithLayout = () => {
  const router = useRouter();
  const getClubSettings = useQuery(GetClubWidgetSettingsDocument, {
    variables: {
      clubId: Number(router.query.clubId),
    },
  });

  return (
    <WidgetsStyle
      widget={{ settings: getClubSettings.data?.widgets_club_settings?.[0] }}
    >
      <WeekEventsWidget
        teams={[]}
        clubId={Number(router.query.clubId)}
        daySwitch={'monday'}
        eventsAwayHome={'all'}
      />
    </WidgetsStyle>
  );
};

export const getStaticPaths = WidgetsLayout.buildGetStaticPaths();

export const getStaticProps = WidgetsLayout.buildGetStaticProps({
  i18n: { namespaces: ['common'] },
});

WeekEvents.getLayout = WidgetsLayout.buildGetLayout();

export default WeekEvents;
